(() => {
  angular
    .module('complianceFrameworkApp.complianceForums')
    .controller('ForumsSearchController', ForumsSearchController);

  /* ngInject */
  function ForumsSearchController($stateParams, forumsSearchService, sessionService) {
    const vm = this;

    vm.currentPage = $stateParams.currentPage || 1;
    vm.getResults = getResults;
    vm.pageChange = pageChange;
    vm.query = $stateParams.query;
    vm.searchResults = [];
    vm.totalCount = null;

    activate();

    function activate() {
      getResults();
    }

    function getResults() {
      forumsSearchService(sessionService.getAuthToken()).search({query: vm.query, page: vm.currentPage}, response => {
        vm.searchResults = response.search_results;
        vm.totalCount = response.meta.total_count;
      });
    }

    function pageChange(newPageNumber, _oldPageNumber) {
      vm.currentPage = newPageNumber;
      getResults();
    }
  }
})();
